import React from "react";
import BannerDevelopment from "../../components/bannerDevelopment";
import NossosServicos from "../../components/nossosServicos";
import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";

export default function Erp() {
    return (
        <>
            <BannerDevelopment
                title="/ERP EXCELLENCE CENTER"
                backgroundUrl="../assets/banner_erp.png"
                imageMobile="banner_erp_mobile.png"
                description={
                    <>
                        Transforme seu negócio e alcance novos resultados{" "}
                        <span className="font-inter-bold">
                            com soluções personalizadas para potencializar o seu
                            ERP.
                        </span>{" "}
                    </>
                }
                bottomText={
                    <>
                        VERTICAL SOLUTIONS |{" "}
                        <span className="font-bold">omni</span>
                        core
                    </>
                }
                bottomTextMobile="VERTICAL SOLUTIONS"
                brand="omnicore"
            />
            <NossosServicos
                servicos={[
                    {
                        id: 1,
                        title: "ERP Expertise",
                        image: "../assets/servicos/erp_expertise_icon.svg",
                        link: "/erp-expertise",
                    },
                    {
                        id: 2,
                        title: "Advisor",
                        image: "../assets/servicos/advisor_icon.svg",
                        link: "/advisor",
                    },
                    {
                        id: 3,
                        title: "AMS",
                        image: "../assets/servicos/ams2_icon.svg",
                        link: "/ams",
                    },
                    {
                        id: 4,
                        title: "Smartsourcing",
                        image: "../assets/servicos/smartsourcing_icon.svg",
                        link: "/smartsourcing",
                    },
                    {
                        id: 4,
                        title: "Consulting",
                        image: "../assets/servicos/consulting_icon.svg",
                        link: "/consulting",
                    },
                ]}
                description="Transforme a forma como sua empresa opera. Maximizamos a eficiência do seu negócio simplificando processos, através do gerenciamento em implementação de soluções ERP."
                bannerImage="../assets/banner-nossos-servicos-erp.png"
                bgColor="from-[#4B3BDB] to-[#A002CB]"
            />
            <BusinessOtimize
                title={
                    <>
                        Mais do que implementar,{" "}
                        <span className="font-inter-bold">
                            nós assumimos o compromisso de fazer o seu ERP
                            funcionar
                        </span>{" "}
                        sem burocracias, com inteligência, eficiência e
                        resultado real.
                    </>
                }
                buttonText="Otimize seu negócio!"
                backgroundImage="../assets/banner-erp-otimize.png"
                bgMobile="../assets/banner-erp-otimize-mobile.png"
                buttonLink="/"
            />
            <Rodape />
        </>
    );
}
